import { render, staticRenderFns } from "./Registra.vue?vue&type=template&id=6b480e6e&scoped=true&"
import script from "./Registra.vue?vue&type=script&scoped=true&lang=js&"
export * from "./Registra.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./Registra.vue?vue&type=style&index=0&id=6b480e6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b480e6e",
  null
  
)

export default component.exports